import React from 'react'
import { Link } from 'react-router-dom'
import styles from './Cards.module.css'

export const Cards = () => {

    return (
        <div className={styles.container}>
            {Array(3)
                .fill()
                .map((item) => (
                    <div className={styles.card}>
                        
                        <div className={styles.leftSection}>
                            <i class="fas fa-user-circle"></i>
                            <button>View</button>
                        </div>
                        <div className={styles.rightSection}>
                            <Link><h1>A Fake Company Ltd</h1></Link>
                            <p>Frank Fake</p>
                            <p>Email: f.fake@google.com, Tel: 07323335565, Address: 23 Test Drive, London, P2 6HF</p>
                            <Link><p>Awaiting Initial Info</p></Link>
                        </div>

                    </div>
                ))}
        </div>
    )
}